import { Component, OnInit, Inject } from "@angular/core";
import { DatabaseService } from "src/_services/DatabaseService";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material";
import { sessionStorage } from "src/app/localstorage.service";
import { ToastrManager } from "ng6-toastr-notifications";
import * as moment from "moment";
import { DialogComponent } from "src/app/dialog.component";

@Component({
  selector: "app-status-modal",
  templateUrl: "./status-modal.component.html",
})
export class StatusModalComponent implements OnInit {
  savingFlag: boolean = false;
  segment: any = {};
  category: any = {};
  urls = new Array<string>();
  login: any = {};
  delivery_from: any;
  selectedFile = [];
  userData: any;
  userId: any;
  userName: any;
  salesUser: any = [];
  organisationData: any = [];
  assignDistArray: any = [];
  drlist: any = [];
  district_list: any = [];
  tmpOrderStatus: any = "";
  segmentList: any = [];
  dr_data: any = [];
  states: any = [];
  statesList: any = [];
  today_date: any = new Date();
  ActiveTab: any = "incoming";
  tabType: any = "stock";
  stockDetails: any = [];
  dr_outDetails: any = [];
  transferRequestData: any = [];
  reqProductDetails: any = [];
  sendProductDetails: any = [];
  dr_inDetails: any = [];
  order_item: any = [];
  warehouse: any = [];
  distributors: any = [];
  fiterdata: any = {};
  yearList: any = []
  currentYear: any = this.today_date.getFullYear()

  contractorMeetDetail: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialog: MatDialog,
    public dialog1: DialogComponent,
    public serve: DatabaseService,
    public session: sessionStorage,
    public toast: ToastrManager,
    public dialogRef: MatDialogRef<StatusModalComponent>
  ) {
    this.StateList();
    for (let i = 2018; i <= this.currentYear; i++) {
      this.yearList.unshift(i)
    }
    this.userData = JSON.parse(localStorage.getItem("st_user"));
    this.data.checkWareHouse = "No";
    this.segment = this.data.segment;
    this.userId = this.userData["data"]["id"];
    this.userName = this.userData["data"]["name"];
    this.delivery_from = this.data.delivery_from;
    console.log('====================================');
    console.log(this.delivery_from);
    console.log(data,'data');
    console.log('====================================');
    if (this.data.from == "primary_order") {
      for (let i = 0; i < this.data.order_item.length; i++) {
        this.order_item.push({
          id: this.data.order_item[i]["id"],
          product_name: this.data.order_item[i]["product_name"],
          product_code: this.data.order_item[i]["product_code"],
          order_qty: this.data.order_item[i]["qty"],
          qty: this.data.order_item[i]["sale_dispatch_qty"],
          dispatch_qty:
            parseInt(this.data.order_item[i]["qty"]) -
            parseInt(this.data.order_item[i]["sale_dispatch_qty"]),
        });
      }
    }

    if(this.data.EventId){
      this.data.partcipantName=this.data.participent_name
      this.data.participantMobile=this.data.participent_mobile
    }
    if (this.data.from == "complaint_status") {
      console.log(this.data);
    }

    this.tmpOrderStatus = this.data.order_status;
    if (this.tmpOrderStatus) {
      this.data.order_status = "";
      this.data.reason = "";
    }
  }

  ngOnInit() {
    if (this.delivery_from == "assignDist") {
      this.distributorList("", this.data.state);
      this.distributorDetail();
    } else if (this.delivery_from == "assignSales") {
      this.distributorDetail();
      this.getSalesUser("");
    }
    else if (this.data.from == "eventlist") {
      this.detailFeedback(this.data.detailId);

    } else if (this.delivery_from == "subcategory-list") {
      this.data.segment_id = this.data.master_category_id.toString();
      this.getSegment();
    } else if (this.delivery_from == "edit_travel_plan_retailer") {
      this.data.employee_id = this.data.employee_id.toString();
      this.data.id = this.data.travel_plan_id.toString();
      this.data.distributor_id = this.data.drId.toString();
      this.allCustomerNetworkList("");
    } else if (this.delivery_from == "add_travel_plan_retailer") {
      this.data.employee_id = this.data.employee_id.toString();
      this.data.id = this.data.travel_plan_id.toString();
      this.allCustomerNetworkList("");
    } else if (this.delivery_from == "month_wise_secondary_sale") {
      this.getStateList();
    } else if (this.delivery_from == "primaryVsSecondaryReport") {
      this.getSalesUser("");
    } else if (this.delivery_from == "ProductWisePrimaryReport") {
      this.getSalesUser("");
    } else if (this.delivery_from == "Stock Report") {
      this.getDistributorList("");
      console.log("call modal stock report", this.delivery_from);
    } else if (this.data.from == "request_product_data") {
      console.log(this.data.reqProductData);
      this.reqProductDetails = this.data.reqProductData.product_details;
      console.log(this.reqProductDetails);
    } else if (this.data.from == "send_product_data") {
      this.sendProductDetails = this.data.sendProductData.product_details;
    } else if (this.data.from == "stock_product_trans") {
      this.dr_outDetails = this.data.stockProductTrans.dr_out;
      this.dr_inDetails = this.data.stockProductTrans.dr_in;
    } else if (this.data.from == "approve_transfer_equest") {
      this.transferRequestData = this.data.requestData;
      this.data.requestId = this.transferRequestData.id;
      console.log(this.data.requestId);
    }

    this.login = JSON.parse(localStorage.getItem("login"));
  }
  reason_reject: any
  detailFeedback(id) {

    this.serve.post_rqst({ 'id': id }, 'Event/eventFeedackDetail').subscribe((resp) => {
      if (resp['statusCode'] == 200) {
        this.contractorMeetDetail = resp['result'][0]
        console.log(this.contractorMeetDetail)
      }
      else {
        this.toast.errorToastr(resp['statusMsg']);
      }
    }, error => {
    })
  }
  primary_order_status_change(reason, status) {
    if (status == "readyToDispatch") {
      for (let i = 0; i < this.order_item.length; i++) {
        let indexValue = i + 1;
        if (this.order_item[i]["qty"] == 0) {
          if (
            parseInt(this.order_item[i]["dispatch_qty"]) >
            this.order_item[i]["order_qty"]
          ) {
            this.toast.errorToastr(
              "Row number " +
              indexValue +
              " remaining QTY. can not be greater than QTY."
            );
            return;
          }
        }
        if (this.order_item[i]["qty"] > 0) {
          if (
            parseInt(this.order_item[i]["dispatch_qty"]) >
            parseInt(this.order_item[i]["order_qty"]) -
            parseInt(this.order_item[i]["qty"])
          ) {
            let value =
              parseInt(this.order_item[i]["order_qty"]) -
              parseInt(this.order_item[i]["qty"]);
            this.toast.errorToastr(
              "Row number " +
              indexValue +
              " Dispatch QTY. can not be greater than remaining QTY. " +
              value
            );
            return;
          }
        }
      }
      this.dialog1
        .confirm("You want to update dispatch planned?")
        .then((result) => {
          if (result) {
            this.savingFlag = true;
            this.serve
              .post_rqst(
                {
                  dispatch_item: this.order_item,
                  status: status,
                  id: this.data.order_id,
                  organisation_id: this.data.organisation_id,
                  warehouse_id: this.data.warehouse_id,
                  action_by: this.login.data.id,
                  uid: this.userId,
                  uname: this.userName,
                },
                "dispatch/dispatchOrderCreate"
              )
              .subscribe((result) => {
                if (result["statusCode"] == 200) {
                  this.dialog.closeAll();
                  this.savingFlag = false;
                  this.toast.successToastr(result["statusMsg"]);
                } else {
                  this.savingFlag = false;
                  this.toast.errorToastr(result["statusMsg"]);
                }
              });
          }
        });
    } else {
      this.savingFlag = true;
      this.serve
        .post_rqst(
          {
            reason: reason,
            status: status,
            warehouse_id: this.data.warehouse_id,
            id: this.data.order_id,
            organisation_id: this.data.organisation_id,
            action_by: this.login.data.id,
            uid: this.userId,
            uname: this.userName,
          },
          "Order/primaryOrderStatusChange"
        )
        .subscribe((result) => {
          if (result["statusCode"] == 200) {
            this.dialog.closeAll();
            this.savingFlag = false;
            this.toast.successToastr(result["statusMsg"]);
          } else {
            this.savingFlag = false;
            this.toast.errorToastr(result["statusMsg"]);
          }
        });
    }
  }
  // Download Stock report Function Start
  filter:any={};
  getDistributorList(searchValue) {
    this.filter.tabType = 'Admin'
    this.serve
      .post_rqst({ search: searchValue, type: 1,'filter':this.filter }, "CustomerNetwork/drList")
      .subscribe((response) => {
        if (response["statusCode"] == 200) {
          this.distributors = response["distributor"];
        } else {
          this.toast.errorToastr(response["statusMsg"]);
        }
      });
  }
  // Download Stock report Function End


  orderfilter() {
    let payload = {};
    payload = {'month': this.data.month, 'year': this.data.year,subtype: this.data.subtype }
    this.dialogRef.close(payload);
  }

  downloadistributorstockreport() {
    this.fiterdata.date_from = moment(this.fiterdata.date_from).format(
      "YYYY-MM-DD"
    );
    this.fiterdata.date_to = moment(this.fiterdata.date_to).format(
      "YYYY-MM-DD"
    );
    this.savingFlag = true;
    this.serve
      .post_rqst({ data: this.fiterdata }, "Stock/distributorWiseStockReport")
      .subscribe(
        (result: any) => {
          if (result["statusCode"] == 200) {
            this.savingFlag = false;
            this.toast.successToastr(result["statusMsg"]);
            window.open(this.serve.uploadUrl + result["filename"]);
            // return true;
          } else {
            this.savingFlag = false;
            this.toast.errorToastr(result["statusMsg"]);
          }
        },
        () => {
          this.savingFlag = false;
          this.toast.errorToastr("Stock Not Found");
        }
      );
  }
  downloadEventCustomizedReport() {
    this.fiterdata.date_from = moment(this.fiterdata.date_from).format(
      "YYYY-MM-DD"
    );
    this.fiterdata.date_to = moment(this.fiterdata.date_to).format(
      "YYYY-MM-DD"
    );
    this.savingFlag = true;
    this.serve
      .post_rqst({ data: this.fiterdata }, "Reports/customisedEventReports")
      .subscribe(
        (result: any) => {
          if (result["statusCode"] == 200) {
            this.savingFlag = false;
            this.toast.successToastr(result["statusMsg"]);
            window.open(this.serve.downloadUrl + result["filename"]);
            // return true;
          } else {
            this.savingFlag = false;
            this.toast.errorToastr(result["statusMsg"]);
          }
        },
        () => {
          this.savingFlag = false;
          this.toast.errorToastr("Something went wrong");
        }
      );
  }

  downloadEventCustomizedReport1() {
    console.log(this.fiterdata.date_from)
    if(this.fiterdata.date_from){
    this.fiterdata.date_from = moment(this.fiterdata.date_from).format(
      "YYYY-MM-DD"
    );
    }else{
      this.fiterdata.date_from=''
    }
    if(this.fiterdata.date_to){
    this.fiterdata.date_to = moment(this.fiterdata.date_to).format(
      "YYYY-MM-DD"
    );
    }else{
      this.fiterdata.date_to=''
    }
    this.savingFlag = true;
    this.serve
      .post_rqst({ data: this.fiterdata }, "Excel/feedbackReport")
      .subscribe(
        (result: any) => {
          if (result['msg'] == true) {
            this.savingFlag = false;
            this.toast.successToastr('Success');
            window.open(this.serve.downloadUrl + result["filename"]);
            // return true;
          } else {
            this.savingFlag = false;
            this.toast.errorToastr(result["statusMsg"]);
          }
        },
        () => {
          this.savingFlag = false;
          this.toast.errorToastr("Something went wrong");
        }
      );
  }
  // Download Stock report Function

  selectWarehouse(value) {
    if (value.value == "Yes") {
      this.serve
        .post_rqst({}, "Dispatch/fetchWarehouse")
        .subscribe((result) => {
          if (result["statusCode"] == 200) {
            this.warehouse = result["result"];
          } else {
            this.toast.errorToastr(result["statusMsg"]);
          }
        });
    } else {
      this.data.warehouse_id = "";
      this.warehouse = [];
    }
  }

  StateList() {
    this.serve
      .post_rqst(0, "Master/getAllStateLocationMaster")
      .subscribe((response) => {
        if (response["statusCode"] == 200) {
          this.statesList = response["all_state"];
        } else {
          this.toast.errorToastr(response["statusMsg"]);
        }
      });
  }

  getDistrict(val) {
    let st_name;
    if (val == 1) {
      st_name = this.data.state;
    }
    this.serve
      .post_rqst({ state_name: st_name }, "Master/getAllDistrictLocationMaster")
      .subscribe((response) => {
        if (response["statusCode"] == 200) {
          this.district_list = response["all_district"];
        } else {
          this.toast.errorToastr(response["statusMsg"]);
        }
      });
  }

  secondary_order_status_change(reason, status) {
    this.savingFlag = true;
    this.serve
      .post_rqst(
        {
          reason: reason,
          status: status,
          id: this.data.order_id,
          action_by: this.login.data.id,
          uid: this.userId,
          uname: this.userName,
        },
        "Order/secondaryOrderStatusChange"
      )
      .subscribe((result) => {
        if (result["statusCode"] == 200) {
          this.dialog.closeAll();
          this.savingFlag = false;
          this.toast.successToastr(result["statusMsg"]);
        } else {
          this.savingFlag = false;
          this.toast.errorToastr(result["statusMsg"]);
        }
      });
  }

  complaintStatusChange() {
    console.log(this.data);

    this.savingFlag = true;
    this.serve
      .post_rqst(
        {
          data: this.data,
          id: this.data.order_id,
          action_by: this.login.data.id,
          uid: this.userId,
          uname: this.userName,
        },
        "Support/complainFinalApprove"
      )
      .subscribe((result) => {
        if (result["statusCode"] == 200) {
          this.dialog.closeAll();
          this.savingFlag = false;
          this.toast.successToastr(result["statusMsg"]);
        } else {
          this.savingFlag = false;
          this.toast.errorToastr(result["statusMsg"]);
        }
      });
  }
  addLocationMaster() {
    console.log(this.data);

    this.savingFlag = true;
    this.serve
      .post_rqst({ data: this.data }, "Master/addLoctionMaster")
      .subscribe((result) => {
        if (result["statusCode"] == 200) {
          this.dialog.closeAll();
          this.savingFlag = false;
          this.toast.successToastr(result["statusMsg"]);
        } else {
          this.savingFlag = false;
          this.toast.errorToastr(result["statusMsg"]);
        }
      });
  }

  getSalesUser(searcValue) {
    this.serve
      .post_rqst({ search: searcValue }, "CustomerNetwork/salesUserList")
      .subscribe((response) => {
        if (response["statusCode"] == 200) {
          this.salesUser = response["all_sales_user"];
        } else {
          this.toast.errorToastr(response["statusMsg"]);
        }
      });
  }

  getCompanyData() {
    this.serve.post_rqst({}, "Order/organizationName").subscribe((response) => {
      if (response["statusCode"] == 200) {
        this.organisationData = response["result"];
      } else {
        this.toast.errorToastr(response["statusMsg"]);
      }
    });
  }

  distributorList(searcValue, state) {
    this.serve
      .post_rqst(
        { search: searcValue, state: state },
        "CustomerNetwork/distributorsList"
      )
      .subscribe((result) => {
        if (result["statusCode"] == 200) {
          this.drlist = result["distributors"];
        } else {
          this.toast.errorToastr(result["statusMsg"]);
        }
      });
  }
  distributorDetail() {
    let id = { id: this.data.drId };
    this.serve
      .post_rqst(id, "CustomerNetwork/distributorDetail")
      .subscribe((result) => {
        if (result["statusCode"] == 200) {
          this.data = result["distributor_detail"];
          this.data.id = result["distributor_detail"]["id"];
          this.data.assigned_sales_user_name =
            this.data["assigned_sales_user_name"].map(String);
          this.data.distributor_id = this.data["distributors_id"].map(String);
        } else {
          this.toast.errorToastr(result["statusMsg"]);
        }
      });
  }

  allCustomerNetworkList(searcValue) {
    this.drlist = [];
    this.serve
      .post_rqst(
        {
          search: searcValue,
          type: this.data.drType,
          employee_id: this.data.employee_id,
        },
        "Travel/drList"
      )
      .subscribe((result) => {
        if (result["statusCode"] == 200) {
          this.drlist = result["result"];
        } else {
          this.toast.errorToastr(result["statusMsg"]);
        }
      });
  }

  getSegment() {
    this.serve
      .post_rqst({}, "Master/getProductCategoryList")
      .subscribe((result) => {
        if (result["category_list"]["statusCode"] == 200) {
          this.segmentList = result["category_list"]["segment_list"];
        } else {
          this.savingFlag = false;
          this.toast.errorToastr(result["category_list"]["statusCode"]);
        }
      });
  }
  UpdateSalesUser() {
    console.log(this.data);
    this.savingFlag = true;
    setTimeout(() => {
      this.serve
        .post_rqst(
          {
            drId: this.data.id,
            userArray: this.data.assigned_sales_user_name,
            company_name: this.data.company_name,
          },
          "CustomerNetwork/drUserAssign"
        )
        .subscribe((result) => {
          if (result["statusCode"] == 200) {
            this.dialog.closeAll();
            this.savingFlag = false;
            this.toast.successToastr(result["statusMsg"]);
          } else {
            this.savingFlag = false;
            this.toast.errorToastr(result["statusMsg"]);
          }
        });
    }, 2000);
  }

  UpdateCountVisit() {
    console.log(this.data);
    this.savingFlag = true;
    setTimeout(() => {
      this.serve
        .post_rqst(
          {
            drId: this.data.id,
            focusVistiCount: this.data.focusVistiCount,
          },
          "CustomerNetwork/updateFocusDealerVisitCount"
        )
        .subscribe((result) => {
          if (result["statusCode"] == 200) {
            this.dialog.closeAll();
            this.savingFlag = false;
            this.toast.successToastr(result["statusMsg"]);
          } else {
            this.savingFlag = false;
            this.toast.errorToastr(result["statusMsg"]);
          }
        });
    }, 2000);
  }

  UpdateDistributor() {
    this.savingFlag = true;
    this.serve
      .post_rqst(
        { drId: this.data.id, distributorId: this.data.distributor_id },
        "CustomerNetwork/dealerDistributorAssign"
      )
      .subscribe((result) => {
        if (result["statusCode"] == 200) {
          this.dialog.closeAll();
          this.savingFlag = false;
          this.toast.successToastr(result["statusMsg"]);
        } else {
          this.savingFlag = false;
          this.toast.errorToastr(result["statusMsg"]);
        }
      });
  }
  UpdateCustomerNetworkTravel() {
    this.savingFlag = true;
    this.serve
      .post_rqst(
        { id: this.data.id, dr_id: this.data.distributor_id },
        "Travel/drChange"
      )
      .subscribe((result) => {
        if (result["statusCode"] == 200) {
          this.dialogRef.close(true);
          this.savingFlag = false;
          this.toast.successToastr(result["statusMsg"]);
        } else {
          this.savingFlag = false;
          this.toast.errorToastr(result["statusMsg"]);
        }
      });
  }

  getDrType(networkData) {
    this.dr_data.push(networkData);
  }

  AddCustomerNetworkTravel() {
    this.savingFlag = true;

    this.serve
      .post_rqst(
        { id: this.data.id, drData: this.dr_data, data: this.data },
        "Travel/addDr"
      )
      .subscribe((result) => {
        if (result["statusCode"] == 200) {
          this.dialogRef.close(true);
          this.savingFlag = false;
          this.toast.successToastr(result["statusMsg"]);
        } else {
          this.savingFlag = false;
          this.toast.errorToastr(result["statusMsg"]);
        }
      });
  }

  MobileNumber(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) { event.preventDefault(); }

  }

  eventParticipateEdit() {
    this.savingFlag = true;
      this.serve.post_rqst({ 'participent_name': this.data.partcipantName,'participent_mobile':this.data.participantMobile, 'eventParticipantId': this.data.EventId,'eventMeetId':this.data.eventMeetId}, "Event/editEventParticipants").subscribe((result => {
        if (result['statusCode'] == 200) {
          this.savingFlag = false;
          this.dialog.closeAll();
          this.toast.successToastr(result['statusMsg']);
        }
        else {
          this.toast.errorToastr(result['statusMsg']);
          this.savingFlag = false;
        }

      }))
  }


  EventAdd() {
    this.savingFlag = true;
      this.serve.post_rqst({ 'partcipantName': this.data.partcipantName,'partcipantType': this.data.partcipantType, 'participantMobile':this.data.participantMobile, 'eventId': this.data.EventId}, "Event/addParticipantsWeb").subscribe((result => {
        if (result['statusCode'] == 200) {
          this.savingFlag = false;
          this.dialog.closeAll();
          this.toast.successToastr(result['statusMsg']);
        }
        else {
          this.toast.errorToastr(result['statusMsg']);
          this.savingFlag = false;
        }

      }))
  }

  EventImageAdd() {
    this.savingFlag = true;
      this.serve.post_rqst({'eventId': this.data.EventId,'image':this.selectedFile,'imageType':this.data.image_type}, "Event/addImagesWeb").subscribe((result => {
        if (result['statusCode'] == 200) {
          this.savingFlag = false;
          this.dialog.closeAll();
          this.toast.successToastr(result['statusMsg']);
        }
        else {
          this.toast.errorToastr(result['statusMsg']);
          this.savingFlag = false;
        }

      }))
  }

  add_segment() {
    this.savingFlag = true;
    this.data.created_by_name = this.userName;
    this.data.created_by_id = this.userId;
    this.serve
      .post_rqst(this.data, "Master/addCategory")
      .subscribe((result) => {
        if (result["statusCode"] == 200) {
          this.toast.successToastr(result["statusMsg"]);
          this.savingFlag = false;
          this.dialogRef.close(true);
          this.serve.count_list();
        } else {
          this.toast.errorToastr(result["statusMsg"]);
          this.savingFlag = false;
        }
      });
  }
  add_subCategory() {
    this.savingFlag = true;
    this.data.created_by_name = this.userName;
    this.data.created_by_id = this.userId;
    this.serve
      .post_rqst(this.data, "Master/addSubCategory")
      .subscribe((result) => {
        if (result["statusCode"] == 200) {
          this.toast.successToastr(result["statusMsg"]);
          this.savingFlag = false;
          this.dialogRef.close(true);
          this.serve.count_list();
        } else {
          this.toast.errorToastr(result["statusMsg"]);
          this.savingFlag = false;
        }
      });
  }

  downloadReport() {
    this.savingFlag = true;
    this.data.date_from
      ? (this.data.date_from = moment(this.data.date_from).format("YYYY-MM-DD"))
      : null;
    this.data.date_to
      ? (this.data.date_to = moment(this.data.date_to).format("YYYY-MM-DD"))
      : null;
    let apiName = "";
    if (this.delivery_from == "tavel_plan") {
      apiName = "Travel/TravelPlanReport";
    }
    this.serve
      .post_rqst(
        { date_from: this.data.date_from, date_to: this.data.date_to },
        apiName
      )
      .subscribe(
        (result: any) => {
          if (result["statusCode"] == 200) {
            this.savingFlag = false;
            window.open(this.serve.downloadUrl + result["filename"]);
            // return true;
          } else {
            this.savingFlag = false;
          }
        },
        () => (this.savingFlag = false)
      );
  }

   setleavingDate() {
    this.savingFlag = true;
    this.data.date_from
      ? (this.data.date_from = moment(this.data.date_from).format("YYYY-MM-DD"))
      : null;
   
    let apiName = "";
    if (this.delivery_from == "userList") {
      apiName = "Master/empLeavingDateUpdate";
    }
    this.serve
      .post_rqst(
        { date: this.data.date_from, id: this.data.user_id },
        apiName
      )
      .subscribe(
        (result: any) => {
          if (result["statusCode"] == 200) {
            this.savingFlag = false;
            this.toast.successToastr(result["statusMsg"]);
            this.dialogRef.close(true);
           
            // return true;
          } else {
            this.savingFlag = false;
          }
        },
        () => (this.savingFlag = false)
      );
  }

  downloadsecondarySaleReport() {
    this.savingFlag = true;
    this.serve
      .post_rqst({ filter: this.data }, "Excel/monthWiseDealerSaleReport")
      .subscribe(
        (result: any) => {
          if (result["statusCode"] == 200) {
            this.savingFlag = false;
            window.open(this.serve.downloadUrl + result["filename"]);
            // return true;
          } else {
            this.savingFlag = false;
          }
        },
        () => (this.savingFlag = false)
      );
  }

  checkValidation(order_qty, qty, dispatch, index) {
    if (qty == 0) {
      if (parseInt(dispatch) > order_qty) {
        this.toast.errorToastr(
          "Row number " + index + " dispatch QTY. can not be greater than QTY."
        );
        return;
      }
    }
    if (qty > 0) {
      if (dispatch > parseInt(order_qty) - parseInt(qty)) {
        let value = parseInt(order_qty) - parseInt(qty);
        this.toast.errorToastr(
          "Row number " +
          index +
          " dispatch QTY. can not be greater than remaining QTY. " +
          value
        );
        return;
      }
    }
  }

  getStateList() {
    this.serve.post_rqst(0, "Influencer/getAllState").subscribe((result) => {
      if (result["statusCode"] == 200) {
        this.states = result["all_state"];
      } else {
        this.toast.errorToastr(result["statusMsg"]);
      }
    });
  }

  requestStatusChange(reason, status) {
    this.savingFlag = true;
    this.serve
      .post_rqst(
        {
          reason: reason,
          status: status,
          requestId: this.data.requestId,
          action_by: this.login.data.id,
          uid: this.userId,
          uname: this.userName,
        },
        "Order/"
      )
      .subscribe((result) => {
        if (result["statusCode"] == 200) {
          this.dialog.closeAll();
          this.savingFlag = false;
          this.toast.successToastr(result["statusMsg"]);
        } else {
          this.savingFlag = false;
          this.toast.errorToastr(result["statusMsg"]);
        }
      });
  }

  salesIn: any = [];
  salesOut: any = [];

  getStock() {
    this.serve
      .post_rqst(
        { id: this.data.stockProductTrans.product_id, dr_id: this.data.id },
        "stock/salesReturnPartyList"
      )
      .subscribe((result) => {
        if (result["statusCode"] == 200) {
          this.salesIn = result["return_in"];
          this.salesOut = result["return_out"];
        } else {
          this.toast.errorToastr(result["statusMsg"]);
        }
      });
  }

  // -----------Purchase sales report Dms --------
  PurchaseOrsalesreportFunc() {
    if (this.fiterdata.date_from) {
      this.fiterdata.date_from = moment(this.fiterdata.date_from).format(
        "YYYY-MM-DD"
      );
    }
    if (this.fiterdata.date_to) {
      this.fiterdata.date_to = moment(this.fiterdata.date_to).format(
        "YYYY-MM-DD"
      );
    }
    let funcname = "";
    if (this.fiterdata.rp_type == "Purchase") {
      funcname = "Stock/datewisePurchaseStockReport";
    } else if (this.fiterdata.rp_type == "Sales") {
      funcname = "Stock/datewiseSaleStockReport";
    } else if (this.fiterdata.rp_type == "Distributor Stock") {
      this.downloadDistributorStockInChunks();
      return;
    } else {
      this.toast.warningToastr("Report Type not selected!");
      return;
    }
    this.savingFlag = true;
    this.serve
      .post_rqst(
        {
          date_from: this.fiterdata.date_from,
          date_to: this.fiterdata.date_to,
        },
        funcname
      )
      .subscribe(
        (result: any) => {
          if (result["statusCode"] == 200) {
            this.savingFlag = false;
            this.toast.successToastr(result["statusMsg"]);
            window.open(this.serve.uploadUrl + result["filename"]);
            // return true;
          } else {
            this.savingFlag = false;
            this.toast.errorToastr(result["statusMsg"]);
          }
        },
        () => {
          this.savingFlag = false;
          this.toast.errorToastr("Something went wrong");
        }
      );
  }

  downloadDistributorStockInChunks() {
    this.savingFlag = true;
    this.serve
      .post_rqst(
        {
          date_from: this.fiterdata.date_from,
          date_to: this.fiterdata.date_to,
        },
        "Stock/distributorStockReport"
      )
      .subscribe(
        (result: any) => {
          if (result["statusCode"] == 400) {
            this.savingFlag = false;
            this.toast.successToastr(result["statusMsg"]);
            window.open(this.serve.uploadUrl + result["filename"]);
            // return true;
          } else if (result["statusCode"] == 200) {
            this.downloadDistributorStockInChunks();
          } else {
            this.savingFlag = false;
            this.toast.errorToastr(result["statusMsg"]);
          }
        },
        () => {
          this.savingFlag = false;
          this.toast.errorToastr("Something went wrong");
        }
      );
  }

  fileChange(event: any) {
    for (var i = 0; i < event.target.files.length; i++) {
      this.selectedFile.push(event.target.files[i]);
      let reader = new FileReader();
      reader.onload = (e: any) => {
        this.urls.push(e.target.result);
        for (let index = 0; index < this.selectedFile.length; index++) {
          for (let urlIndex = 0; urlIndex < this.urls.length; urlIndex++) {
            if (index == urlIndex) {
              this.selectedFile[index]['path'] = this.urls[urlIndex];
            }
          }
        }
      }
      reader.readAsDataURL(event.target.files[i]);
    }
  }
  remove_image(i: any) {
    console.log(i);
    this.urls.splice(i, 1);
    this.selectedFile.splice(i, 1);
  }
}
